import React from 'react';

const CharacterSection = ({
  title,
  children,
  imageUrl,
  imageAlt = 'Samba character illustration',
  imagePosition = 'right',
  backgroundColor = 'white'
}) => {
  return (
    <div className={`py-16 px-4 ${backgroundColor}`}>
      <div className="max-w-6xl mx-auto">
        <div className={`flex flex-col ${imagePosition === 'right' ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 md:gap-12`}>
          {/* Content */}
          <div className="flex-1">
            <h2 className="text-4xl font-bold mb-8 text-[#2E0854]">{title}</h2>
            <div className="prose max-w-none">
              {children}
            </div>
          </div>
          
          {/* Image */}
          <div className="w-full md:w-1/3 flex justify-center">
            <img
              src={imageUrl}
              alt={imageAlt}
              className="w-48 md:w-64 h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharacterSection;